module.exports = __webpack_public_path__ + "static/ma-7-c6adf118a6de3458e75a40cd76b9020c.png";